/* eslint-disable sort-keys-fix/sort-keys-fix, typescript-sort-keys/interface, camelcase */
/*
 * This code is generated by ../../../scripts/generateSchemas.ts.
 * Do not adapt manually. Instead run 'yarn generate'.
 *
 * Source: ../../types/pure-multiple-choice-exercise/v0.ts
 */

import { createValidator } from '../../helpers/validator';
export var PureMultipleChoiceExerciseV0Schema = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  type: 'object',
  properties: {
    title: {
      type: 'string'
    },
    assignment: {
      type: 'string'
    },
    hint: {
      type: 'string'
    },
    possible_answers: {
      type: 'array',
      items: {
        type: 'string'
      }
    },
    feedbacks: {
      type: 'array',
      items: {
        type: 'string'
      }
    },
    xp: {
      type: 'number'
    },
    course_id: {
      type: 'number'
    },
    chapter_id: {
      type: 'number'
    }
  },
  required: ['title', 'assignment', 'hint', 'possible_answers', 'feedbacks', 'xp', 'course_id', 'chapter_id'],
  definitions: {}
};
export var isValidPureMultipleChoiceExerciseV0 = createValidator(PureMultipleChoiceExerciseV0Schema);
export var PureMultipleChoiceExerciseV0Definition = {
  schema: PureMultipleChoiceExerciseV0Schema,
  validate: isValidPureMultipleChoiceExerciseV0
};